import {
  Component,
  ElementRef,
  OnInit,
  ViewChild
} from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import swal from "sweetalert2";
import { ModalBasicComponent } from "../../shared/modal-basic/modal-basic.component";
import { ActivatedRoute, Router } from "@angular/router";
import { ProductPointsCatalogService } from "../../master-services/productPointsCatalog/product-points-catalog.service";
import { IProductPoints } from "../../master-models/productPoints.model";
import { UserService } from "../../master-services/User/user.service";
import { CustomerTypesService } from "../../master-services/customer-types/customer-types.service";
import { ICustomerType } from "../../master-models/customer-type.model";
import { CustomerPointsService } from "../../master-services/customer-points/customer-points.service";
import { ICustomerPoints, ICustomerPointsDetails, SpendCustomerPoints } from "../../master-models/customer-points.model";
import { RestService } from "../../master-services/Rest/rest.service";
import { CustomerRedeemService } from "../../master-services/customer-redeem/customer-redeem.service";
import { ICustomerRedeems } from "../../master-models/customer-redeem.model";
import { CUSTOMER_POINTS_STATES } from "../../constants/customer-points-states";
import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-master-product-points-catalog",
  templateUrl: "./master-product-points-catalog.component.html",
  styleUrls: [
    "./master-product-points-catalog.component.scss",
    "../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class MasterProductPointsCatalogComponent implements OnInit {
  products: IProductPoints[] = [];
  customerTypes: ICustomerType[] = [];
  customerPoints: ICustomerPoints[] = [];
  customerRedeems: ICustomerRedeems[] = [];
  productForm: FormGroup;
  productImage: File | null= null;
  updateProductForm: FormGroup;
  updateProductImage: File | null = null;
  updateProductImagePreview: string = null;
  updatingProductId = null;
  updatingProduct: IProductPoints = null;
  isCustomerUser = false;
  isAdvisorUser = false;
  justStock = false;
  currentCustomer: any;
  customerPointsDetails: ICustomerPointsDetails;
  showingPointsHistory = false;
  showingRedeemsHistory = false;
  selectedStatus = '';
  pointStates = CUSTOMER_POINTS_STATES;
  fromDate: NgbDateStruct;
  untilDate: NgbDateStruct;
  considerDate = false;

  private readonly ADMIN_OVERRIDE_USER_IDS: number[] = [308];

  @ViewChild('modalRegisterProductPoints') modalRegisterProductPoints: ModalBasicComponent;
  @ViewChild('modalUpdateProductPoints') modalUpdateProductPoints: ModalBasicComponent;
  @ViewChild('productImageInput') productImageInput: ElementRef;
  @ViewChild('updateProductImageInput') updateProductImageInput: ElementRef;

  constructor(
    private productCatalogService: ProductPointsCatalogService,
    private userService: UserService,
    private customerTypesService: CustomerTypesService,
    private customerPointsService: CustomerPointsService,
    private customerRedeemsService: CustomerRedeemService,
    private restService: RestService,
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    const profile = Number(localStorage.getItem("profile"));
    const userId = Number(localStorage.getItem("userid"));
    const isAdminOverride = this.ADMIN_OVERRIDE_USER_IDS.indexOf(userId) !== -1;

    if (profile == 10) {
      this.getCustomerUser(userId);
      this.isCustomerUser = true;
      this.justStock = true;
      this.getCustomerTypes();
    } else if ((profile == 2 || profile == 3) && !isAdminOverride) {
      this.isAdvisorUser = true;
      this.justStock = true;
      this.getCustomerTypes();
    } else {
      this.generateProductForm();
    }

    this.getProductsList();
  }

  generateProductForm() {
    this.productForm = this.fb.group({
      name: ['', [
        Validators.required
      ]],
      amount: [null, [
        Validators.required
      ]],
      price: [null, [
        Validators.required
      ]],
    });
  }
  
  generateUpdateProductForm(product: IProductPoints) {
    this.updateProductForm = this.fb.group({
      name: [product.name, [
        Validators.required
      ]],
      amount: [product.amount, [
        Validators.required
      ]],
      price: [product.price, [
        Validators.required
      ]],
    });
  }

  toggleModalPoductForm() {
    if (this.modalRegisterProductPoints.visible) {
      this.productImage = null;
      this.productForm.reset();
      this.productImageInput.nativeElement.value = '';
      this.modalRegisterProductPoints.hide();
      return;
    }

    this.modalRegisterProductPoints.show();
  }

  toggleModalUpdatePoductForm(product: IProductPoints = null) {
    if (this.modalUpdateProductPoints.visible) {
      this.updateProductForm.reset();
      this.updatingProductId = null;
      this.updatingProduct = null;
      this.resetUpdateProductImage();
      this.modalUpdateProductPoints.hide();
      return;
    }

    this.updatingProductId = product.id;
    this.updatingProduct = product;
    this.resetUpdateProductImage();
    this.generateUpdateProductForm(product);
    this.modalUpdateProductPoints.show();
  }

  togglePointsHistory() {
    this.showingRedeemsHistory = false;
    this.showingPointsHistory = !this.showingPointsHistory;
  }
  
  toggleRedeemsHistory() {
    this.showingPointsHistory = false;
    this.showingRedeemsHistory = !this.showingRedeemsHistory;
  }

  onImageSelected(event: Event) {
    const fileInput = event.target as HTMLInputElement;
    if (fileInput.files && fileInput.files.length > 0) {
      this.productImage = fileInput.files[0];
    }
  }

  onUpdateImageSelected(event: Event) {
    const fileInput = event.target as HTMLInputElement;
    if (fileInput.files && fileInput.files.length > 0) {
      this.updateProductImage = fileInput.files[0];
      this.updateProductImagePreview = URL.createObjectURL(this.updateProductImage);
    }
  }

  resetUpdateProductImage() {
    this.updateProductImage = null;
    if (this.updateProductImagePreview) {
      URL.revokeObjectURL(this.updateProductImagePreview);
    }
    this.updateProductImagePreview = null;
    if (this.updateProductImageInput) {
      this.updateProductImageInput.nativeElement.value = '';
    }
  }

  onDateSelectionFrom(date: any) {
    if (this.untilDate && this.fromDate) {
      const fromD = new Date(this.fromDate.year, this.fromDate.month, this.fromDate.day);
      const untilD = new Date(this.untilDate.year, this.untilDate.month, this.untilDate.day);

      if (fromD > untilD) {
        this.untilDate = { ...this.fromDate };
      }

      if (this.considerDate && this.fromDate && this.untilDate) {
        this.getCustomerPoints(this.currentCustomer.id);
      }
    }
  }

  onDateSelectionUntil(date: any) {
    if (this.fromDate && this.untilDate) {
      const fromD = new Date(this.fromDate.year, this.fromDate.month, this.fromDate.day);
      const untilD = new Date(this.untilDate.year, this.untilDate.month, this.untilDate.day);

      if (untilD < fromD) {
        this.fromDate = { ...this.untilDate };
      }

      if (this.considerDate && this.fromDate && this.untilDate) {
        this.getCustomerPoints(this.currentCustomer.id);
      }
    }
  }

  changeConsiderDate(event) {
    this.considerDate = !this.considerDate;
    this.getCustomerPoints(this.currentCustomer.id);
  }
  
  createProduct() {
    if (this.productForm.invalid || !this.productImage) {
      swal({
        title: "Informacion incompleta",
        text: "Ingrese todos los valores requeridos (*)",
        type: "error",
      });
      return;
    }

    swal({
      title: "Guardando información ...",
      allowOutsideClick: false,
    });

    const formData = new FormData();
    formData.append('name', this.productForm.value.name);
    formData.append('price', this.productForm.value.price);
    formData.append('amount', this.productForm.value.amount);
    formData.append('image', this.productImage);

    this.productCatalogService.createProduct(formData)
      .subscribe({
        next: res => {
          this.getProductsList();
          this.toggleModalPoductForm();
          swal.close();
        },
        error: e => {
          swal.close();
          swal({
            title: 'Error al guardar',
            text: 'No se pudo completar el proceso. Intente nuevamente.',
            type: 'error',
          });
        }
      });
  }
  
  updateProduct() {
    if (this.updateProductForm.invalid) {
      swal({
        title: "Informacion incompleta",
        text: "Ingrese todos los valores requeridos (*)",
        type: "error",
      });
      return;
    }

    swal({
      title: "Guardando información ...",
      allowOutsideClick: false,
    });

    const payload = this.updateProductImage ? this.buildUpdateProductFormData() : this.updateProductForm.value;

    this.productCatalogService.updateProduct(this.updatingProductId, payload)
      .subscribe({
        next: res => {
          this.getProductsList();
          this.toggleModalUpdatePoductForm();
          swal.close();
        },
        error: e => {
          swal.close();
          swal({
            title: 'Error al guardar',
            text: 'No se pudo completar el proceso. Intente nuevamente.',
            type: 'error',
          });
        }
      });
  }

  private buildUpdateProductFormData(): FormData {
    const formData = new FormData();
    formData.append('_method', 'PATCH');
    formData.append('name', this.updateProductForm.value.name);
    formData.append('price', this.updateProductForm.value.price);
    formData.append('amount', this.updateProductForm.value.amount);
    formData.append('image', this.updateProductImage);

    return formData;
  }

  claimProduct(productId: number) {
    swal({
      title: 'Deseas canejar este articulo?',
      text: 'Esta accion no se puede deshacer.',
      showCancelButton: true,
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'Cancelar',
    }).then(res => {
      if (res.value) {
        swal({
          title: "Guardando información ...",
          allowOutsideClick: false,
        });
    
        const spendBody: SpendCustomerPoints = {
          customer_id: this.currentCustomer.id,
          product_id: productId,
          amount: 1,
          user_id: Number(localStorage.getItem("userid")),
        }
    
        this.customerPointsService.spendPoints(spendBody)
          .subscribe({
            next: res => {
              this.getProductsList();
              this.getCustomerPoints(this.currentCustomer.id);
              this.getCustomerRedeems(this.currentCustomer.id);
              swal.close();
            },
            error: e => {
              swal.close();
              swal({
                title: 'Error al reclamar',
                text: 'No se pudo completar el proceso. Intente nuevamente.',
                type: 'error',
              });
            }
          });
      }
    });
  }

  calculateCustomerPointsDetails() {
    this.customerPointsDetails = {
      expired: 0,
      available: 0,
      total: 0,
      spent: 0
    };
    
    this.customerPoints.forEach(points => {
      if (points.canceled === 0) {
        if (points.expired === 1) {
          this.customerPointsDetails.expired += (points.amount - points.amount_spent);
        } else {
          this.customerPointsDetails.available += (points.amount - points.amount_spent);
        }

        this.customerPointsDetails.total += points.amount;
        this.customerPointsDetails.spent += points.amount_spent;
      }
    });
  }

  getProductsList() {
    this.productCatalogService.getProductsList(this.justStock)
      .subscribe(res => {
        this.products = res.data;
      });
  }

  getCustomerUser(id: any) {
    this.userService
      .getUserCustomer(id)
      .then((data) => {
        const resp: any = data;
        const customerId = resp.data[0].id;
        this.getCustomer(customerId);
        this.getCustomerPoints(customerId);
        this.getCustomerRedeems(customerId);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getCustomerTypes() {
    this.customerTypesService.getTypes()
      .subscribe(res => {
        this.customerTypes = res.data;
      });
  }

  getCustomerPoints(id: number) {
    let fromDateStr = '';
    let untilDateStr = '';

    if (this.considerDate && this.fromDate && this.untilDate) {
      fromDateStr = `${this.fromDate.year}-${String(this.fromDate.month).padStart(2, '0')}-${String(this.fromDate.day).padStart(2, '0')}`;
      untilDateStr = `${this.untilDate.year}-${String(this.untilDate.month).padStart(2, '0')}-${String(this.untilDate.day).padStart(2, '0')}`;
    }

    this.customerPointsService.getCustomerPoints(id, this.selectedStatus, fromDateStr, untilDateStr)
      .subscribe(res => {
        this.customerPoints = res.data;
        console.log(this.customerPoints)
        this.calculateCustomerPointsDetails();
      });
  }
  
  getCustomerRedeems(id: number) {
    this.customerRedeemsService.getRedeems(id)
      .subscribe(res => {
        this.customerRedeems = res.data;
      });
  }

  getCustomer(id: number) {
    this.restService.getSpecificCustomer(id)
      .then(data => {
        const resp: any = data;
        this.currentCustomer = resp.data;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/master/master-product-points-catalog/master-product-points-catalog.component.ts